// extracted by mini-css-extract-plugin
export default {"iconExternalLink":"iconExternalLink_awgD"};